<script lang="ts">
  import { alertStore, dismissAlert } from '../lib/ui-alert';
  import Icon from './Icon.svelte';

  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape' || e.key === 'Enter') dismissAlert();
  }
</script>

<svelte:window onkeydown={onKeydown} />

{#if $alertStore}
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-[#191527]/40 backdrop-blur-[3px] p-4"
    role="presentation"
    onclick={dismissAlert}
  >
    <div
      class="w-[min(420px,95vw)] rounded-2xl border border-[var(--color-border-3)] bg-white shadow-2xl overflow-hidden"
      role="alertdialog"
      aria-modal="true"
      onclick={(e) => e.stopPropagation()}
    >
      <div class="flex items-start gap-3 px-5 py-4">
        <span class="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-rose-50 text-rose-600">
          <Icon name="warning" size={18} />
        </span>
        <div class="flex-1 min-w-0 pt-0.5">
          <div class="text-sm font-semibold">{$alertStore.title}</div>
          <p class="mt-1 text-[13px] leading-relaxed text-[var(--color-text-muted)] whitespace-pre-wrap break-words">
            {$alertStore.message}
          </p>
        </div>
      </div>
      <div class="flex justify-end px-5 py-3 border-t border-[var(--color-border-3)]">
        <button
          type="button"
          onclick={dismissAlert}
          class="btn-pu rounded-lg px-4 py-2 text-xs font-semibold"
        >Зрозуміло</button>
      </div>
    </div>
  </div>
{/if}
